export const MINIMIUM_CARACTERS = 6;
export const ROUTE_WALLET = '/carteira';
export const DOLAR_TURISMO = 'USDT';
export const TAG_ALIMENTO = 'Alimentação';
export const TAG_OPTIONS = ['Alimentação', 'Lazer', 'Trabalho', 'Transporte', 'Saúde'];
export const METHOD_OPTIONS = ['Dinheiro', 'Cartão de crédito', 'Cartão de débito'];
export const thColumns = [
  'Descrição',
  'Tag',
  'Método de pagamento',
  'Valor',
  'Moeda',
  'Câmbio utilizado',
  'Valor convertido',
  'Moeda de conversão',
  'Editar/Excluir',
];
